export default "/assets/images/app-update-img-02.7a7ccf6994c0b346.webp";